<template>
    <deal-proposal-list-row :deal="deal" :proposal="current_proposal">
        <div v-if="deal.proposals.length > 1" class="field has-addons mt-15">
            <p class="control">
                <button class="button is-small is-static">{{ capitalize(deal.duration_interval) }}:</button>
            </p>
            <p v-for="proposal in deal.proposals" :key="proposal.id" class="control">
                <a
                    class="button is-small"
                    :class="{
                        'is-outlined': current_proposal_id !== proposal.id,
                        'is-success': proposal.deal_status === 'current',
                        'is-primary': current_proposal_id === proposal.id
                    }"
                    @click.prevent="current_proposal_id = proposal.id"
                >
                    {{ proposal.deal_position }}
                </a>
            </p>
        </div>
    </deal-proposal-list-row>
</template>

<script>
    import DealProposalListRow from './DealProposalListRow.vue';
    import capitalize from 'lodash-es/capitalize';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'DealProposalList',

        /**
         * The child components
         *
         * @type {Object}
         */
        components: {
            DealProposalListRow
        },

        /**
         * The component properties
         *
         * @type {object}
         */
        props: {
            /**
             * The deal
             */
            deal: {
                type: Object,
                required: true
            }
        },

        /**
         * The component data
         *
         * @returns {object}
         */
        data() {
            return {
                /**
                 * The current proposal id
                 *
                 * @type {string|null}
                 */
                current_proposal_id: null
            };
        },

        /**
         * The computed properties
         *
         * @type {object}
         */
        computed: {
            /**
             * The current proposal
             *
             * @returns {object}
             */
            current_proposal() {
                let current;

                if (this.current_proposal_id) {
                    current = this.deal.proposals.filter((p) => p.id === this.current_proposal_id);
                } else {
                    current = this.deal.proposals.filter((p) => p.deal_status === 'current');
                }

                return current.length ? current[0] : this.deal.proposals[0];
            }
        },
        methods: {
            capitalize(value) {
                return capitalize(value);
            }
        },

        /**
         * When the component is created
         */
        created() {
            this.$nextTick(() => {
                if (!this.current_proposal_id && this.current_proposal) {
                    this.current_proposal_id = this.current_proposal.id;
                }
            });
        }
    };
</script>

<style lang="scss" scoped>
    .field.has-addons {
        flex-wrap: wrap;

        .control {
            margin-bottom: -1px;
        }
    }
</style>
